import {SlateMarkBase} from "shared/controls/SingleInputs/SlateEditor/Marks/SlateMarkBase";
import {SlateEditor} from "shared/controls/SingleInputs/SlateEditor/SlateEditor";
import {ReactNode} from "react";
import * as React from "react";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {FontUploader} from "InternalShared/Dialog/FileUploader";
import {Mark} from "slate";
import {LicenseIsRequired} from "InternalShared/Dialog/LicenseIsRequired";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";


export class FontFamilyMark extends SlateMarkBase{

    public editor:SlateEditor;
    GetMark(editor: SlateEditor<any>): ReactNode {
        this.editor=editor;
        return (
            <select value={this.GetCurrentFont()} style={{height:25,padding:0,width:100,marginLeft:5}} onChange={e=>this.FontChanged(e.target.value)}>
                <option value={''}>Default</option>
                {rednaoVar.AvailableFonts.map(x=>
                    <option key={x} value={x}>{x}</option>
                )}

                <option value={'dejavu sans'}>Deja vu (Pre installed)</option>
                <option value={'$add_new'}>Add Font</option>
            </select>
        )
    }


    private GetCurrentFont() {
        let currentColor=this.editor.state.value.activeMarks.find(x=>x.type=='family');
        if(currentColor!=null)
            return currentColor.data.get('family');
        return '';
    }

    private async FontChanged(font: string) {
        if(font=='')
        {
            this.editor.state.value.marks.forEach(mark=>{
                if(mark.type=='family')
                    this.editor.editor.removeMark(mark);
            });

            return;
        }
        if(font=="$add_new"){
            if(rednaoVar.IsPr=='')
            {
                Dialog.Show(<LicenseIsRequired Message={"Custom fonts are only available in the full version"}/>);
                return;
            }

            let result=await Dialog.Show(<FontUploader/>);
            if(result==''||result==null) {
                return;
            }
            font=result;
        }

        this.editor.state.value.marks.forEach(mark=>{
            if(mark.type=='family')
                this.editor.editor.removeMark(mark);
        });
        this.editor.editor.toggleMark(Mark.create({type:'family',data:{family:font}}));


    }

    RenderMark( mark,children,attributes): ReactNode {
        if(mark.type=='family')
        {
            return <span {...attributes} style={{fontFamily:mark.data.get('family')}}>{children}</span>
        }

        return null;
    }

    Serialize(el:HTMLElement,next:any)
    {
        if(el.style!=null&&el.style.fontFamily!='')
            return {
                object: 'mark',
                type: 'family',
                data: {
                    family: el.style.fontFamily,
                },
                nodes: next(el.childNodes)
            };

        return null;
    }

}